import BaseApi from '@lumapps/base-api';

/**
 * marketplace-library is a SHARED-CELL service (same one the dev-portal calls),
 * so target the shared cell — `useShared` builds `${Config.sharedCell}/${path}`.
 * base-api attaches the platform Syn JWT automatically.
 */
const marketplaceLibraryApi = new BaseApi({
    useShared: true,
    path: 'v2/marketplace-users/me/login-url',
});

export interface DeveloperPortalLoginUrl {
    url: string;
}

export const getDeveloperPortalLoginUrl = async (): Promise<DeveloperPortalLoginUrl> => {
    const { data } = await marketplaceLibraryApi.post<DeveloperPortalLoginUrl>('', undefined);
    return data;
};
